// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './openSurvey/assets/common.css'
// import '../static/style/theme/index.css'
// import '../static/style/theme/index.css'
import MyAxios from './utils/request'
import Tool from './utils/tool';
import i18n from './lang/index'
import store from './store'

Vue.config.productionTip = false

window.axios = require('./axios').default;
Vue.use(ElementUI);
Vue.prototype.$axios = MyAxios;
Vue.prototype.$tool = Tool;
Vue.prototype.$message = ElementUI.Message;

window.instance = require('./axios').default
window.surveyUrl = '/retailink-management/survey'
window.retailogUrl = '/retailink-management/retailogService'
window.retailinkUrl = '/retailink-management/retailinkManagerService'
window.woUrl = '/retailink-management/woManagerService'
window.pubServer = '/retailink-management/pubServer'
window.commonServer = '/retailink-management/commonServer/'
// topdoorReqUrl = '/retailink-management/topdoorService'
window.uploadUrl = window.retailinkUrl + '/resource/upload?clientId=' + 'c24e5467-901c-11ee-a1d5-00163e3041a8'

window.oprReqUrl = '/retailink-management/opr-service/'
window.vmsReqUrl = '/retailink-management/vms-service/'
window.openSurveyReqUrl = '/retailink-management/openSurvey-service/'
window.topdoorReqUrl = '/retailink-management/topdoor-service/'

window.vmsUrl = 'retailink-management/#/vms/activityManage'
window.oprUrl = 'retailink-management/#/opr/homeTotal'
window.skipWoUrl = 'wmp-management/calendar'
window.listenUUrl = 'survey-management/#/index'
window.skipRetailogUrl = 'retailog-management/log/doorLog?menuCode=7A41C8E7783C'
window.skipRetailinkUrl = 'retailink-management/#/home'
window.openSurveyUrl = 'retailink-management/#/openSurvey/taskManage'


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js